const settings = window.settings;

const authConfig = {
    authority: settings.oidc.authority,
    clientId: settings.oidc.clientId,
    baseUrl: settings.baseUrl,
    logoutUri: settings.oidc.logoutUri,
};

const settingsService = {
    settings,
    authConfig
}

export default settingsService;